import { render, staticRenderFns } from "./ViewAwardee.vue?vue&type=template&id=5c88f580&"
import script from "./ViewAwardee.vue?vue&type=script&lang=js&"
export * from "./ViewAwardee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewAwardee.vue"
export default component.exports